import { mandiService, velynkService } from "./base";

export const getMyBuys = (params) => {
  return mandiService.get(`/auction_lot`, {
    params,
  });
};

export const getCustomerDetails = (id, params) => {
  return velynkService.get(`/customers/${id}/basic_details`, { params });
};

export const getMyPayments = (params) => {
  return velynkService.get("customer_mandis/get_mandi_payments.json", {
    params,
  });
};

export const getAllMyPayments = (params) => {
  return velynkService.get("cds/customer_ledger/customer_payments", { params });
};

export const getOverallCreditDetails = (params) => {
  return velynkService.get(`customers/get_mandi_customer_credit_details.json`, {
    params,
  });
};
